import API_BASE_URL from "./apiBase";
import { ADMIN_TOKEN_KEY } from "./projects";

// Admin list of channel partners (brokers): newest first, searchable, paged.
export async function listChannelPartners({ q = "", project = "", skip = 0, limit = 50 } = {}) {
  const params = new URLSearchParams({ skip, limit });
  if (q) params.set("q", q);
  if (project) params.set("project", project);
  const response = await fetch(`${API_BASE_URL}/api/v1/channel-partner?${params}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem(ADMIN_TOKEN_KEY) || ""}` },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Could not load channel partners");
  return body.data;
}

// Same endpoint the Channel Partner registration form uses.
export async function registerChannelPartner(partner) {
  const response = await fetch(`${API_BASE_URL}/api/v1/channel-partner/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(partner),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.message || "Could not register the channel partner");
  return body;
}
